// Shared contact behavior for menu planners; custom events keep flexible logistics.
(() => {
 const form=document.querySelector('form[data-contact-prefix]');
 if(!form)return;
 const prefix=form.dataset.contactPrefix,flexible=form.dataset.contactFlexible==='true';
 const field=name=>document.getElementById(`${prefix}-${name}`);
 const personal=document.getElementById(prefix==='side'?'sides-personal':`${prefix}-personal`);
 const dateText=value=>{const [y,m,d]=value.split('-').map(Number);return new Date(y,m-1,d).toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});};
 const timeText=value=>{const [h,m]=value.split(':').map(Number);return `${h%12||12}:${String(m).padStart(2,'0')} ${h>=12?'PM':'AM'}`;};
 function sync(){
  const service=field('service').value.toLowerCase();
  const pickup=service==='pickup',undecided=service==='help me decide';
  const needsAddress=!pickup&&!undecided;
  const timeLabel=field('time-label');
  if(timeLabel)timeLabel.textContent=`Preferred ${pickup?'pickup':undecided||service.includes('hosted')||service.includes('staffed')?'event':'delivery'} time (optional)`;
  if(!flexible){
   field('address-label').hidden=!needsAddress;
   field('address').disabled=!needsAddress;
   field('address').required=needsAddress;
  }
  const name=field('name');
  name.setCustomValidity(name.value&&!name.value.trim()?'Enter your name.':'');
  if(!flexible&&needsAddress){const address=field('address');address.setCustomValidity(address.value&&!address.value.trim()?'Enter the delivery address or venue.':'');}
 }
 function render(){
  if(!personal)return;
  const lines=[];
  for(const [key,label] of [['name','Name'],['email','Email'],['phone','Phone']]){
   const value=field(key).value.trim();if(value)lines.push(`${label}: ${value}`);
  }
  if(prefix==='side'){
   if(field('pairing').value)lines.push('Main catering menu: '+field('pairing').value);
   if(field('guests').value)lines.push('Guests: '+field('guests').value);
  }
  lines.push('Service: '+field('service').selectedOptions[0].textContent);
  if(field('date').value)lines.push('Date: '+dateText(field('date').value));
  lines.push(field('time').value?field('time-label').textContent.replace(' (optional)','')+': '+timeText(field('time').value):'Time: to confirm');
  if(!field('address').disabled&&field('address').value.trim())lines.push('Location: '+field('address').value.trim());
  if(field('notes').value.trim())lines.push('Requests: '+field('notes').value.trim());
  personal.textContent=lines.join('\n');
 }
 // Capture updates requirements before the page calculator runs; render afterward.
 for(const event of ['input','change']){
  form.addEventListener(event,sync,true);
  form.addEventListener(event,render);
 }
 form.addEventListener('submit',render);
 sync();render();
})();
